import React, { useContext } from "react";

import { StickerWrapper, SubscriptionPlansWrapper } from "./SubscriptionDetails.style";
import { planDetails } from "./subscriptionUtil";
import { UserSubscriptionValueContext } from "./SubscriptionDetails";


const SubscriptionPlans = () => {
    const { subscriptionPlanDetails, setSubscriptionPlanDetails, setCurrentStep } = useContext(UserSubscriptionValueContext);

    const handleSelectedPlan = (planDetails, data) => {
        setSubscriptionPlanDetails({
            planTitle: planDetails.planTitle,
            planName: planDetails.planName,
            subType: data?.type || "",
            allowedSubjects: data?.allowedSubjects,
            price: data?.price,
            subTypeName: data.subTypeName,
        });
        setCurrentStep(2);
    };

    return (
        <SubscriptionPlansWrapper subscriptionPlanDetails={subscriptionPlanDetails}>
            <div className="main-container">
                <div className="select-plan-plate">
                    <div className="select-plan">Select a plan</div>
                </div>
                <div className="plans">
                    {planDetails
                        ?.filter((planDetailsObj) => planDetailsObj.planName === subscriptionPlanDetails?.planName)?.[0]
                        ?.subType?.map((subTypeDetailsObj) => {
                            return (
                                <StickerWrapper
                                    stickerImage={subTypeDetailsObj?.stickerImage}
                                    hoverEffectColor={subTypeDetailsObj?.hoverEffectColor}
                                    onClick={() => handleSelectedPlan(subscriptionPlanDetails, subTypeDetailsObj)}
                                    className={`${subTypeDetailsObj?.type === subscriptionPlanDetails?.subType ? "selected" : ""}`}
                                />
                            );
                        })}
                </div>
            </div>
        </SubscriptionPlansWrapper>
    );
};

export default SubscriptionPlans
